import { api } from "@/services/api";

export interface WaitingListBody {
  email: string;
  full_name: string;
}

export const waitingListApi = {
  async join(body: WaitingListBody) {
    await api.post("/waiting-list", body);
  },
};
